import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { Accessorial } from '../../types';

export interface GetCustAccessorialRequestParams {
  inlineSearch?: {
    CustomerKey?: number;
    CargoType?: string;
    AccChargeCode?: string;
    IsActive?: boolean;
    IsMandatory?: boolean;
  };
}

export const getCustAccessorialByCargoTypeAPI = (params: GetCustAccessorialRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.MASTER_DATA_PUBLIC}/customer-accessorial-cargo-type`,
  });
};

export type CustAccessorialResponse = {
  items: Accessorial[];
  totalCount: number;
};

export const fetchCustAccessorialByCargoType = async (
  params: GetCustAccessorialRequestParams,
): Promise<CustAccessorialResponse> => {
  const response: AxiosResponse<CustAccessorialResponse> = await getCustAccessorialByCargoTypeAPI(params);

  // Workaround. TODO: remove when WI 27119 is completed
  const data = {
    ...(response?.data || {}),
    items: response?.data?.items?.filter((item) => item.cargoType === params.inlineSearch?.CargoType),
  };

  return data;
};
